/**
 * Descarga un archivo blob con el nombre especificado
 * @param blob El blob del archivo a descargar
 * @param fileName Nombre del archivo incluyendo la extensión
 */
export const downloadFile = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
